export default __webpack_public_path__ + "static/media/watchedMovie.78fc3dc6.png";